// extracted by mini-css-extract-plugin
export default {"current":"PageButton_current__xE-OY","link":"PageButton_link__t6+xx","item":"PageButton_item__pMQUh"};